import { useContext, useEffect, useRef, useState } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";
import { redirectingToLoginMessage } from "../../app/constant/loadingMessages";
import { Loader } from "../_components/Loader";
import { NotFound } from "@intouchhealth/cig-components";
import { ClockOutOfSync } from "../../app/constant/errorMessages";

const MAX_LOGIN_ATTEMPTS = 3;

const LandingPage = () => {
  const rootStore = useContext(RootStoreContext);
  const { login } = rootStore.userStore;
  const didLogRef = useRef(false);
  const [loopDetected, setLoopDetected] = useState(false);

  useEffect(() => {
    if (didLogRef.current === false) {
      didLogRef.current = true;
      const attempts = Number(
        window.sessionStorage.getItem("loginAttempts") ?? "0",
      );
      if (attempts >= MAX_LOGIN_ATTEMPTS) {
        setLoopDetected(true);
        return;
      }
      window.sessionStorage.setItem("loginAttempts", String(attempts + 1));

      login();
    }
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  if (loopDetected) {
    return (
      <NotFound
        errorData={ClockOutOfSync}
        onClick={() => {
          window.sessionStorage.removeItem("loginAttempts");
          window.location.assign("/");
        }}
      />
    );
  }

  return <Loader message={redirectingToLoginMessage} />;
};

export default LandingPage;
